<template>
  <el-dialog
    :fullscreen="$mq === 'sm'"
    :visible="dialog.visible"
    @update:visible="updateDialog"
  >
    <div class="container-fluid pb-4">
      <div class="row justify-content-center">
        <iframe
          v-if="item.type === 'enjoj\\feed\\VideoItem'"
          :src="embedVideo(item.itemable.video_url)"
          width="560"
          height="315"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'ec-business-dialog',
  data () {
    return {
      item: {}
    }
  },
  computed: {
    ...mapState([
      'dialog'
    ])
  },
  methods: {
    ...mapMutations([
      'setDialog'
    ]),
    embedVideo (url) {
      let urlParams = this.getParams(url)

      return 'https://www.youtube.com/embed/' + urlParams['v'] + '?autoplay=1'
    },
    getParams (url) {
      let params = {}
      url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        params[key] = value
      })

      return params
    },
    updateDialog (value) {
      let data = {
        type: '',
        content: {},
        visible: value
      }
      this.setDialog(data)
    }
  },
  mounted () {
    this.item = this.dialog.content
  }
}
</script>
